import api from './api';
import {
  Vertragsartikel, VertragsartikelUebersicht,
  CreateVertragsartikelRequest, UpdateVertragsartikelRequest,
} from '../types';

export const vertragsartikelService = {
  // Liefert die Positionen samt vorgerechneter Summen (netto / MwSt je Satz / brutto).
  getByVertrag: async (vertragId: number): Promise<VertragsartikelUebersicht> => {
    const response = await api.get(`/vertraege/${vertragId}/artikel`);
    return response.data;
  },

  create: async (vertragId: number, data: CreateVertragsartikelRequest): Promise<Vertragsartikel> => {
    const response = await api.post(`/vertraege/${vertragId}/artikel`, data);
    return response.data;
  },

  update: async (id: number, data: UpdateVertragsartikelRequest): Promise<Vertragsartikel> => {
    const response = await api.put(`/vertragsartikel/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/vertragsartikel/${id}`);
  },
};

export default vertragsartikelService;
